const isAdmin = (role) => {
    if (role === 'super' || role === 'admin') return true
    return false
}

const users = {
    isAdmin,
}

export default users